import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const pad = (n) => String(n).padStart(2, "0");
const fmt = (d) => `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;

const Line = ({ children, delay }) => (
  <span className="block overflow-hidden pb-[0.08em]">
    <motion.span
      className="block"
      initial={{ y: "105%" }}
      animate={{ y: 0 }}
      transition={{ duration: 1, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const LiveTitle = ({ compact }) => {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const t = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(t);
  }, []);
  const time = fmt(now);

  useEffect(() => {
    document.title = `this place reviewed at ${time}`;
  }, [time]);

  if (compact) {
    return (
      <h1 data-testid="live-clock-title" className="font-display text-xl leading-tight">
        this place reviewed at <span className="font-mono-clock text-[var(--amber)]">{time}</span>
      </h1>
    );
  }

  return (
    <h1
      data-testid="live-clock-title"
      className="font-display font-light leading-[0.92] tracking-tight text-[clamp(2.4rem,7.2vh,6.2rem)] lg:text-[clamp(3rem,9vh,7rem)]"
    >
      <Line delay={0.1}>this place</Line>
      <Line delay={0.22}>
        <em className="italic font-normal">reviewed</em> at
      </Line>
      <Line delay={0.34}>
        <span data-testid="live-clock-time" className="font-mono-clock font-semibold text-[var(--amber)] tracking-tighter text-[0.82em]">
          {time}
        </span>
      </Line>
    </h1>
  );
};
